module.exports = __webpack_public_path__ + "static/img/xingfz.84f6801.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/About/xingfz.png
// module id = +UY7
// module chunks = 98